export const TripStatusOptions = [
	{ value: '1', label: 'Reported' },
	{ value: '2', label: 'Trip Start' },
	{ value: '3', label: 'Trip End' },
];

export const validTripOptions = [
	{ value: true, label: 'Valid' },
	{ value: false, label: 'Invalid' },
];
